// extracted by mini-css-extract-plugin
module.exports = {"container":"PdpRespSidebarBlurbs__container__a433a852"};